module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110260-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110260-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("Abbreviations Used by Scott")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110260-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "ta"
    }
  }, [_c('caption', [_c('br')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("1. Advocate, The")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Advocate, Sir William Rae")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("2. C and Coy.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Constable and Company")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("3. Ch. Ba.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Chief Baron of the Exchequer Court, Sir Samuel Shepherd")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("4. Ch. Com.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Chief Commissioner of the Jury Court, the Rt. Hon. William Adam")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("5. Chief Baron")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 3 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("6. Chief Commissioner")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 4 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("7. H & R")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Hurst, Robinson and Company")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("8. James  "), _c('br'), _vm._v("James B "), _c('br'), _vm._v("J. B.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "xvii.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("James Ballantyne ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("9. J. G. L.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("John Gibson Lockhart")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("10. L. C. B.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 3 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("11. L. C. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 4 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("12. Lord Ch: Com.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 4 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("13. L. J. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Justice-Clerk, the Rt. Hon. David Boyle")])]), _vm._v(" "), _c('tr', {
    staticClass: "row14"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("14. L. J. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Lady Jane Stuart")])]), _vm._v(" "), _c('tr', {
    staticClass: "row15"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("15. L. L. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Lady Louisa Stuart")])]), _vm._v(" "), _c('tr', {
    staticClass: "row16"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("16. Lord Register")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Principal Keeper of the Register of Sasines, the Rt. Hon. William Dundas")])]), _vm._v(" "), _c('tr', {
    staticClass: "row17"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("17. L. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Lady Scott")])]), _vm._v(" "), _c('tr', {
    staticClass: "row18"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("18. Missie")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Miss Macdonald Buchanan")])]), _vm._v(" "), _c('tr', {
    staticClass: "row19"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("19. R. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Robert Cadell")])]), _vm._v(" "), _c('tr', {
    staticClass: "row20"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("20. Sir A. F.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Sir Adam Ferguson")])]), _vm._v(" "), _c('tr', {
    staticClass: "row21"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("21. Solicitor, The")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Solicitor-General, John Hope")])]), _vm._v(" "), _c('tr', {
    staticClass: "row22"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("22. S. W. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Sir Walter Scott")])]), _vm._v(" "), _c('tr', {
    staticClass: "row23"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("23. W. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Will Clerk")])]), _vm._v(" "), _c('tr', {
    staticClass: "row24"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("24. "), _c('i', [_vm._v("W—k")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Woodstock")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110260-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac6bc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_chapter_01.vue
// module id = 72
// module chunks = 0